import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["overlay", "modal", "message", "error", "success", "submit"]
  static values = { endpoint: String }

  open() {
    this.hideMessages()
    this.overlayTarget.classList.remove("hidden")
    this.modalTarget.classList.remove("hidden")
    this.messageTarget.focus()
  }

  close() {
    this.overlayTarget.classList.add("hidden")
    this.modalTarget.classList.add("hidden")
    this.messageTarget.value = ""
    this.hideMessages()
  }

  closeFromOverlay(event) {
    if (event.target === this.overlayTarget) {
      this.close()
    }
  }

  async submit(event) {
    event.preventDefault()
    this.hideMessages()

    const message = this.messageTarget.value.trim()
    if (!message) {
      this.errorTarget.textContent = "Feedback message cannot be blank."
      this.errorTarget.classList.remove("hidden")
      return
    }

    this.submitTarget.disabled = true
    this.submitTarget.textContent = "Submitting..."

    try {
      const response = await fetch(this.endpointValue, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": this.csrfToken
        },
        body: JSON.stringify({
          feedback_submission: {
            message,
            page_url: window.location.href
          }
        })
      })

      if (!response.ok) {
        const data = await response.json()
        throw new Error(data.errors?.join(", ") || "Unable to submit feedback.")
      }

      this.messageTarget.value = ""
      this.successTarget.classList.remove("hidden")
    } catch (error) {
      this.errorTarget.textContent = error.message
      this.errorTarget.classList.remove("hidden")
    } finally {
      this.submitTarget.disabled = false
      this.submitTarget.textContent = "Submit"
    }
  }

  hideMessages() {
    this.errorTarget.classList.add("hidden")
    this.successTarget.classList.add("hidden")
    this.errorTarget.textContent = ""
  }

  get csrfToken() {
    return document.querySelector("meta[name='csrf-token']")?.content || ""
  }
}
